import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.852 4.545a1.84 1.84 0 0 1 2.629 2.577L11.684 19.37a1.843 1.843 0 0 1-2.65.05L2.54 12.926a1.841 1.841 0 1 1 2.604-2.603l5.137 5.139 8.523-10.86a1 1 0 0 1 .05-.056z"
    }, null, -1)
  ])))
}
export default { render: render }